export const subtitles = {
    "1": {
        "startTime": 6.87,
        "endTime": 8.23,
        "transcript": "Yaa, kitakwa.",
        "translation": "Okay, ready."
    },
    "2": {
        "startTime": 8.385,
        "endTime": 14.68,
        "transcript": "Ii-i, au͡gna apyutkellren, ca ukveqciqsia?",
        "translation": "Okay, what you just asked, what would I believe?"
    },
    "3": {
        "startTime": 14.68,
        "endTime": 19.65,
        "transcript": "Au͡gkut ciuliaput, ciuliamta waniwa ukveqaqkiit.",
        "translation": "Our ancestors, this is what our ancestors believed."
    },
    "4": {
        "startTime": 19.84,
        "endTime": 24.34,
        "transcript": "Una-gguq waniw' arcaqerluku wangkuta ukveqkilaut:",
        "translation": "They said that we should especially believe this:"
    },
    "5": {
        "startTime": 24.465,
        "endTime": 29.195,
        "transcript": "Mat'um-gguq Ellam Yuan tangvagaakut kanavet.",
        "translation": "They said that the Spirit of the Universe is watching us below."
    },
    "6": {
        "startTime": 29.285,
        "endTime": 34.785,
        "transcript": "Tauna-gguq nalluyagucaqunata. Ellam Yuan-gguq tangvagaakut.",
        "translation": "They said we shouldn't forget that. They said that the Spirit of the Universe is watching us."
    },
    "7": {
        "startTime": 34.95,
        "endTime": 45.63,
        "transcript": "Tua-i-llu-gguq taum wani nallunrilkumteggu qanrucunarluta-gguq pikilta.",
        "translation": "Then they said that if we know that, we should take heed to advice."
    },
    "8": {
        "startTime": 46.565,
        "endTime": 50.275,
        "transcript": "Qanruyuteput maligtaquluki.",
        "translation": "We should follow the wisdom passed down to us."
    },
    "9": {
        "startTime": 50.445,
        "endTime": 59.805,
        "transcript": "Tauna-gguq tua-i wangkuta piluaqautekaqerput qanrucunallerput, narurcivkenata yuuluta.",
        "translation": "They said that we would do well to take heed to advice, living without going against them."
    },
    "10": {
        "startTime": 59.84,
        "endTime": 70.19,
        "transcript": "Tua-i-llu-gguq ukut ciulirnemta waten piciqaakut: \"Ellualriamek yugmek aterpag...\"",
        "translation": "Then they said that our elders would say this to us: \"A person who is called righteous...\""
    },
    "11": {
        "startTime": 70.19,
        "endTime": 71.25,
        "transcript": "...qanellren.",
        "translation": "...what you said."
    },
    "12": {
        "startTime": 73.765,
        "endTime": 84.295,
        "transcript": "Una-gguq nalluyagutenrilkumteggu arcaqerluku Ellam Yuanun tangvaucirput, taum umyuartumek cikirciqaakut.",
        "translation": "They said that if we do not forget that the Spirit of the Universe is watching us, that [Spirit] will give us wisdom."
    },
    "13": {
        "startTime": 84.495,
        "endTime": 90.405,
        "transcript": "Narurcilriaruvkarngaunata-llu ciulirnemta ayuqucirtuutaitnek.",
        "translation": "And [the Spirit] will not have us disregard our elders' instructions."
    },
    "14": {
        "startTime": 90.485,
        "endTime": 96.14,
        "transcript": "Tuaten-llu-gguq pikumta umyuarturiarkauluta.",
        "translation": "And they said that if we do that, we will become wise."
    },
    "15": {
        "startTime": 96.14,
        "endTime": 100.71,
        "transcript": "Qanyulimek-lu aterpagcimaarkauluta.",
        "translation": "And we will be called articulate [teachers]."
    },
    "16": {
        "startTime": 100.71,
        "endTime": 105.66,
        "transcript": "Waten-llu: qanellra-gguq nakrarkauguq taum.",
        "translation": "And like this: what he says must be accurate."
    },
    "17": {
        "startTime": 105.7,
        "endTime": 110.4,
        "transcript": "Qanellri-gguq tamarmeng piciulriaruarkaugut.",
        "translation": "They said that everything he says must be true."
    },
    "18": {
        "startTime": 110.415,
        "endTime": 116.015,
        "transcript": "Qanruciicetun-llu-gguq tuaten qanruciatun piarkauluteng.",
        "translation": "And they said that things would go as they say."
    },
    "19": {
        "startTime": 116.84,
        "endTime": 127.33,
        "transcript": "Uum-gguq Ellam Yuan quyakekunikut tuaten ayuqlirivkarciqaakut, qigcikekumteggu callemteńi tamalkuitni.",
        "translation": "They said that if the Spirit of the Universe is grateful to us, he will make us like that if we respect him through everything we do."
    },
    "20": {
        "startTime": 127.43,
        "endTime": 137.16,
        "transcript": "Tua-i-llu-gguq qigcikekumteggu, ciulirneput-gguq tau͡gaam tamalkuita qigcikekumteggu Ellam Yuan qigcikciqerput.",
        "translation": "Then they said that if we respect him, only if we respect all of our elders, we will respect the Spirit of the Universe."
    },
    "21": {
        "startTime": 137.22,
        "endTime": 140.26,
        "transcript": "Tua-i tuaten qanruyutiit.",
        "translation": "That's their traditional wisdom."
    },
    "22": {
        "startTime": 141.175,
        "endTime": 153.905,
        "transcript": "Mat'umek niicuileng'e'rmeng tuqumalriit maktellerkaatnek, yuk umyuarteq'lallrulliniut tua-i yuk tuqukan tuquarkauyukluku yuunqigtarkaunrirluku.",
        "translation": "Through they never heard about the dead rising again, they used to think that if a person dies, he is dead and will never live again."
    },
    "23": {
        "startTime": 154.875,
        "endTime": 166.495,
        "transcript": "Nallunrilkuvgu-wa elpet piciryaran, allat-llu-qaa piciryaraita assilria wall' assiilnguq piciryaraitni nallunricugngaan?",
        "translation": "So if you know your ways, will you also be able to know what is good or bad in others' ways as well?"
    },
    "24": {
        "startTime": 168.45,
        "endTime": 170.19,
        "transcript": "Yaa, yaa.",
        "translation": "Yes, yes."
    },
    "25": {
        "startTime": 170.195,
        "endTime": 175.185,
        "transcript": "Man'a allat yuut piciryaraat",
        "translation": "About other people's ways"
    },
    "26": {
        "startTime": 176.335,
        "endTime": 187.41,
        "transcript": "Waniwa ukut allat yuut piciryaraat waniwa, akusrarteḿun ukut calilriit Kass'anek aterpagingalriit",
        "translation": "Other people's ways here, the people who are called Caucasian work toward commotion"
    },
    "27": {
        "startTime": 187.41,
        "endTime": 192.8,
        "transcript": "Makutgun-llu tiiviitgun arcaqerluku piciryaraq man'a",
        "translation": "And especially the ways through these TV's"
    },
    "28": {
        "startTime": 192.9,
        "endTime": 200.57,
        "transcript": "Ellailkarcaraq ciuliamta inerquutekellrat, akusrarcaraq arcaqerluku cimigulluku",
        "translation": "Acting senselessly as our ancestors admonished against, focusing especially on being mischievous"
    },
    "29": {
        "startTime": 200.57,
        "endTime": 204.26,
        "transcript": "Yumteńun-llu ilaitnun cumigutevkarluku",
        "translation": "And having some of our people focusing on it as well"
    },
    "30": {
        "startTime": 204.42,
        "endTime": 209.49,
        "transcript": "Man'a akusrarcaraq ukut aipamta allat yuut waniwa.",
        "translation": "This mischievous ways of our counterparts, the other people."
    },
    "31": {
        "startTime": 210.97,
        "endTime": 216.43,
        "transcript": "Assilria-mi ca piciryaraat assirta Kass'at?",
        "translation": "So, what's a good way of the West?"
    },
    "32": {
        "startTime": 218.115,
        "endTime": 221.51,
        "transcript": "Assilriamek-qaa Kass'at piciryaraat?",
        "translation": "You mean a good Western custom?"
    },
    "33": {
        "startTime": 221.51,
        "endTime": 223.17,
        "transcript": "Allat-wa tua-i yuut.",
        "translation": "Well, other people."
    },
    "34": {
        "startTime": 224.185,
        "endTime": 233.015,
        "transcript": "Makut wangkuta Yugni piciryararput assilria waten-am ayuqut cali:",
        "translation": "Our good Yup'ik ways are also like this:"
    },
    "35": {
        "startTime": 233.305,
        "endTime": 244.075,
        "transcript": "Nunani tamaitni ciuliaput qanrucunarluki, neplirpek'naki-llu yuusqeng'e'rmegteki.",
        "translation": "Heed the advice of our elders in every village, even if they want them to live without commotion."
    },
    "36": {
        "startTime": 244.075,
        "endTime": 249.53,
        "transcript": "Tau͡gaam-am erneq atauciq qanrutketulliniat.",
        "translation": "But they talk about one day."
    },
    "37": {
        "startTime": 249.53,
        "endTime": 257.68,
        "transcript": "Yuk tuani ernermi akusrarteng'e'rmi tua-i ernerpak yaavet tupallerminek ayagluku",
        "translation": "In that day, though a person is mischievous all day starting from when he wakes up"
    },
    "38": {
        "startTime": 257.74,
        "endTime": 267.26,
        "transcript": "Ikingqaluni-gguq, qasgimi-llu imumi neplisciigalkiitni nepliryaraq ikingqaluni ataucimi.",
        "translation": "They said [the opportunity] was open, and in the community house where they couldn't have commotion, having commotion was open for one [day]."
    },
    "39": {
        "startTime": 267.265,
        "endTime": 269.415,
        "transcript": "Tuaten-gguq ayuqluteng.",
        "translation": "They said that's what they were like."
    },
    "40": {
        "startTime": 269.415,
        "endTime": 278.685,
        "transcript": "Tang ata uitarrlainarcetevkenaki tuaten pivkaraqluki pilallinikait.",
        "translation": "You see, they wouldn't have them stay [queit] all the time, but have them do that."
    },
    "41": {
        "startTime": 278.685,
        "endTime": 286.895,
        "transcript": "Tamatum-gguq tau͡gken tauna erneq pelluan tuaten-am pisqevkenaki, tua-i nepaunaki uitasqelluki.",
        "translation": "However, they said that when that day passed, they told them not to do that, told them to stay quietly."
    },
    "42": {
        "startTime": 287.085,
        "endTime": 298.795,
        "transcript": "Tua-i tamaaggun imumek waten angniryuumilallrat ernermek-am ataucimek cikirluki tuaten pilallinilriit ciuliaput.",
        "translation": "Since they wanted to be happy like this through that, our ancestors would give them one [day] like that."
    },
    "43": {
        "startTime": 298.795,
        "endTime": 304.435,
        "transcript": "Allat-mi yuut waten assilria piciryaraat qaill' nallunriciiqsia?",
        "translation": "So, how will I know other people's good ways?"
    },
    "44": {
        "startTime": 306.27,
        "endTime": 314.73,
        "transcript": "Waten ilamta yuut allat piciryaraat assilria tangerqumteggu.",
        "translation": "If we see our peers, other people's, good ways like this."
    },
    "45": {
        "startTime": 314.915,
        "endTime": 317.995,
        "transcript": "Waten au͡gkut ciuliaput ayuqut:",
        "translation": "This is what our ancestors were like back then:"
    },
    "46": {
        "startTime": 318.7,
        "endTime": 329.17,
        "transcript": "Au͡gkuni tuntuni quyurtaatulini uitallruunga. Allakarmeng-llu ukut Mamterillerni nakmiin pimeggnek tuntungqertut.",
        "translation": "I lived over there were they herded reindeer. And they had separate rendeer here in Bethel that were their very own."
    },
    "47": {
        "startTime": 329.19,
        "endTime": 336.92,
        "transcript": "Akiarmi-llu nakmiin tunturluteng, Akiacuarmi-llu, pagaani-llu ingrini.",
        "translation": "And they had their own reindeer in Akiak, and in Akiachak, and up in the mountains."
    },
    "48": {
        "startTime": 337.03,
        "endTime": 343.92,
        "transcript": "Taukut-llu allakaqtaarluteng waten quyurtaalartut pillgutkevkenateng.",
        "translation": "Those would herd separately like this without working together."
    },
    "49": {
        "startTime": 343.92,
        "endTime": 347.88,
        "transcript": "Tua-i-llu piqerluteng waten qanlartut:",
        "translation": "Then they would occassionally say this:"
    },
    "50": {
        "startTime": 347.885,
        "endTime": 356.955,
        "transcript": "Tang taukumiut wall' Akiarmiut wall' Mamterillermiut tuaten piarkauluki. Tuntuteng ukut aulukqatallinikiit.",
        "translation": "You see, the people from there or Akiak or Bethel would do that. They would take care of their own reindeer."
    },
    "51": {
        "startTime": 356.955,
        "endTime": 363.235,
        "transcript": "Assirluni-ll' tamana taqellrat piciryaraat.",
        "translation": "And that custom they'd established was good."
    },
    "52": {
        "startTime": 363.32,
        "endTime": 367.65,
        "transcript": "Angu ataki wangkuta tamaagguiqaalta.",
        "translation": "Never would we go through there."
    },
    "53": {
        "startTime": 367.66,
        "endTime": 374.27,
        "transcript": "Tuaten piyaurrluta assilliniuq taman' piciryaraat maligcunaqluni.",
        "translation": "It was good that we started doing that, and their way was easy to follow."
    },
    "54": {
        "startTime": 374.5,
        "endTime": 383.17,
        "transcript": "Tamaa-i assilria piciryaraq maliggluku pilallruut inglukutevkenateng.",
        "translation": "They would follow that good way without rivaling each other."
    },
    "55": {
        "startTime": 383.57,
        "endTime": 390.63,
        "transcript": "Mat'um nalliini tuaten ayuqsunarqukut wangkuta Yup'ik Nation-aarullemteńi.",
        "translation": "These days, we should be like that as a Yup'ik Nation."
    },
    "56": {
        "startTime": 390.635,
        "endTime": 395.525,
        "transcript": "Nunarraat ukut tamarmeng ayuqenrilngurnek piciryararrangqertut.",
        "translation": "All of these villages have different customs."
    },
    "57": {
        "startTime": 395.525,
        "endTime": 398.945,
        "transcript": "Cali-ll' ayuqenrilngurnek taqiucugluteng.",
        "translation": "They also want to accomplish different things."
    },
    "58": {
        "startTime": 400.21,
        "endTime": 412.93,
        "transcript": "Taringcetaarutekluku, ukut-am camek assinrulriamek qaqiutelliniut Atmaulluarmiut, wangkuta-llu ciungani tamatumek qaqiuteksaunata.",
        "translation": "As an example, the people here from Atmauthluak have accomplished something better, and we had never accomplished that before."
    },
    "59": {
        "startTime": 412.935,
        "endTime": 422.685,
        "transcript": "Maaten yuvrirarput wangkuta tuaggun taqellratgun pikumta piluaqerciqlinilriakut assinrulriakun.",
        "translation": "We examined it and realized that if we did what they accomplished, we would do well through something better."
    },
    "60": {
        "startTime": 422.685,
        "endTime": 423.435,
        "transcript": "Camek?",
        "translation": "What?"
    },
    "61": {
        "startTime": 423.995,
        "endTime": 427.625,
        "transcript": "Mat'um nunamta auluklerkaanek.",
        "translation": "How to take care of our land."
    },
    "62": {
        "startTime": 427.625,
        "endTime": 432.645,
        "transcript": "Cali-llu nunamta piklerkaatnek, wangkutnun tusngallerkaanek.",
        "translation": "Also to own our land, that it should be set to us [in our care]."
    },
    "63": {
        "startTime": 432.7,
        "endTime": 439.13,
        "transcript": "Tuaggun-llu pikumta wangkuta umyuallgutekluta pinirikanirluta.",
        "translation": "If we also do that with one mind, we will become stronger."
    },
    "64": {
        "startTime": 439.13,
        "endTime": 440.45,
        "transcript": "Cauluni?",
        "translation": "What is it?"
    },
    "65": {
        "startTime": 440.455,
        "endTime": 444.09,
        "transcript": "Nepailngurkun ayagarkauluta.",
        "translation": "We will proceed without commotion."
    },
    "66": {
        "startTime": 444.09,
        "endTime": 445.95,
        "transcript": "Waniwa caucia:",
        "translation": "Here's what it is:"
    },
    "67": {
        "startTime": 446.025,
        "endTime": 458.76,
        "transcript": "Man'a nunavut nakmiin pivut wangkuta teguluku ataniurarkauluku, allamun pikestekenrilkiinun Kass'amun ataniurcetevkenaku.",
        "translation": "We take this land of our very own and govern it, without letting others, Caucasians, who do not own it govern it."
    },
    "68": {
        "startTime": 458.76,
        "endTime": 465.93,
        "transcript": "Au͡gkut ciuliamta ataniullruciatun nunavut man'a ataniurarkauluku",
        "translation": "We would govern our land as our ancestors governed it back then"
    },
    "69": {
        "startTime": 465.93,
        "endTime": 470.71,
        "transcript": "Naken allamun tekitanek yaaqvanun ataniurcetevkenaku.",
        "translation": "Without letting others who've come from far away govern it."
    },
    "70": {
        "startTime": 470.715,
        "endTime": 478.485,
        "transcript": "Tamaa-i tamana elluaq assilria ayuquciat maliggluku wangkuta piarkauluku.",
        "translation": "We would do that in accordance to the right and good way they were."
    },
    "71": {
        "startTime": 478.485,
        "endTime": 486.44,
        "transcript": "Ukut tau͡gken aipaimta piciryaraat aturluku pikumta neplirarkaulliniluta.",
        "translation": "However, if we follow the way of our counterparts, we will come to discord."
    },
    "72": {
        "startTime": 486.44,
        "endTime": 490.29,
        "transcript": "Calluagarkauluteng, piksugiiluteng tuaten.",
        "translation": "They will fight, and even claim ownership."
    },
    "73": {
        "startTime": 490.297,
        "endTime": 497.747,
        "transcript": "Qanemyuugararkauluteng-llu tuaggun yuk piyuaniluku ellaita nunautemegteggun.",
        "translation": "They will also grumble, saying that a person is walking through their land there."
    },
    "74": {
        "startTime": 497.747,
        "endTime": 502.277,
        "transcript": "Wangkuta Yugni tuaten ciuliaput piitut.",
        "translation": "We Yup'ik people's ancestors did not have that."
    },
    "75": {
        "startTime": 503.087,
        "endTime": 507.737,
        "transcript": "Nepailngurkun tau͡gaam assilriakun yuullruut.",
        "translation": "Instead, they lived well without commotion."
    },
    "76": {
        "startTime": 508.687,
        "endTime": 515.487,
        "transcript": "Unuamek maa-i amllermi angayuqait tamarmeng calilartut akingengnaqluteng.",
        "translation": "Many times today, all of their parents work to earn money."
    },
    "77": {
        "startTime": 515.892,
        "endTime": 525.642,
        "transcript": "Tamatum-mi, tamakuni-mi irniangqerquneng kia irniarit piciryaramteńek alerquaqatartaki?",
        "translation": "Among those, if they have children, who is going to teach their children about our culture?"
    },
    "78": {
        "startTime": 526.112,
        "endTime": 534.542,
        "transcript": "Mat'um nalliini waten ayuqut: ukut aipaimta akingengnaqluteng.",
        "translation": "These days, they're like this: they try to earn money as our counterparts."
    },
    "79": {
        "startTime": 534.762,
        "endTime": 543.772,
        "transcript": "Them even though some are instructed to work to earn money",
        "translation": "Them even though some are instructed to work to earn money"
    },
    "80": {
        "startTime": 543.772,
        "endTime": 552.482,
        "transcript": "Akingaqameng taangamun tau͡gaam tunluki usviirutekluki, akngirqutekluki, picurlagatekluki-llu.",
        "translation": "When they get money, they only give it to alcohol to become crazy, hurt others, and get into misfortune."
    },
    "81": {
        "startTime": 552.482,
        "endTime": 560.662,
        "transcript": "Ukut angayuqaita tuaten pisqenrilengraiceteng, elluarrluki akingutait aulukesqengraiteki",
        "translation": "They they tell their parents not to do that, to frugally take care of their money"
    },
    "82": {
        "startTime": 560.667,
        "endTime": 564.782,
        "transcript": "Auluksugpeg'naki umyugailkarutekluki tau͡gken.",
        "translation": "They don't take care of them, but use it to act insensibly."
    },
    "83": {
        "startTime": 564.782,
        "endTime": 569.812,
        "transcript": "Taumek ilait caliarpaurraarluki ciqitelarait.",
        "translation": "That's why after making the work a lot, they fire them."
    },
    "84": {
        "startTime": 569.812,
        "endTime": 577.782,
        "transcript": "Tamarmek angayuqait caliluteng, ukut-llu mikelnguut kia qanrutqatartaki ernerpak cataiterr[aarluteng]?",
        "translation": "When both of their parents are working, who is going to teach these children after they're gone all day?"
    },
    "85": {
        "startTime": 578.562,
        "endTime": 586.252,
        "transcript": "Ukuk angayuqaulriik elicungcarciqakek qalarulluki caliyaramek.",
        "translation": "These parents will teach them, talking to them about how to work."
    },
    "86": {
        "startTime": 586.252,
        "endTime": 596.722,
        "transcript": "Waniwauguq-llu taum caliangqellerkaa angutem wall'u arnam:",
        "translation": "This is also how that person should work, a man or a woman:"
    },
    "87": {
        "startTime": 596.722,
        "endTime": 599.792,
        "transcript": "Niisngakuni tau͡gaam caliarpaugarkauguq.",
        "translation": "They will only work hard if they're obedient."
    },
    "88": {
        "startTime": 599.792,
        "endTime": 601.932,
        "transcript": "Nuu, taringeksaitan apyutka.",
        "translation": "No, you didn't understand my question."
    },
    "89": {
        "startTime": 601.937,
        "endTime": 603.727,
        "transcript": "Unuamek irniangqe[llriit]...",
        "translation": "Those with children today..."
    },
    "90": {
        "startTime": 604.797,
        "endTime": 612.967,
        "transcript": "Makut unuamek calilriit angayuqait, ilaita-llu paisterluteng",
        "translation": "These parents who work today, and some have babysitters"
    },
    "91": {
        "startTime": 613.117,
        "endTime": 617.877,
        "transcript": "Ilaita paistaita waten ayuqut:",
        "translation": "Some of their babysitters are like this:"
    },
    "92": {
        "startTime": 618.312,
        "endTime": 620.552,
        "transcript": "Acivaqaniryugluteng.",
        "translation": "They tend to curse."
    },
    "93": {
        "startTime": 620.557,
        "endTime": 628.112,
        "transcript": "Mikcuayagaat-llu imkut paistemeng qanellritnek qallalluteng acivaqaniyagaraqluteng.",
        "translation": "And the little ones would speak like their babysitters, swearing."
    },
    "94": {
        "startTime": 628.112,
        "endTime": 631.412,
        "transcript": "Cauciinaku tamana, taringuma[vkenaku].",
        "translation": "They don't know what that is, don't understand it."
    },
    "95": {
        "startTime": 631.417,
        "endTime": 638.652,
        "transcript": "Ilii tau͡gken paistem kinguagni angayuqaagni ayuqucirturluki.",
        "translation": "Yet some babysitters, instruct them after their parents [leave]."
    },
    "96": {
        "startTime": 638.652,
        "endTime": 643.072,
        "transcript": "Akultuluni-ll' tuatnalria paigiluni assirluni.",
        "translation": "And one who does that is rare who babysits well."
    },
    "97": {
        "startTime": 643.077,
        "endTime": 650.892,
        "transcript": "Ayuqucirturluki elluarrluki pillerkaatnek, niisngallerkaatnek-llu mikyaangraata.",
        "translation": "He instructs them on how to do well, and to be obedient though they're very small."
    },
    "98": {
        "startTime": 650.892,
        "endTime": 654.322,
        "transcript": "Assiilngurmek ayuqucirturpek'naki.",
        "translation": "He doesn't instruct them on bad things."
    },
    "99": {
        "startTime": 654.362,
        "endTime": 664.402,
        "transcript": "Au͡gkut nallunritua tanglartua-ll' mikcuayagaunge'rmeng ilait cacirteng nallunge'rmegteggu acivaqanirnaurtut.",
        "translation": "I know and see some very small children curse though they don't know what they're doing."
    },
    "100": {
        "startTime": 664.407,
        "endTime": 672.857,
        "transcript": "Uum paisteteng, paistiita iqlutun ayuqucirturluki yuucurlallerkaatnek tayima.",
        "translation": "Their babysitter teachings them wrong on how to lead bad lives."
    },
    "101": {
        "startTime": 672.876,
        "endTime": 680.898,
        "transcript": "Qaillun-mi unuamek wani makut ayagyuaput wangkuta imucetun agturluki?",
        "translation": "So today, how will we emotionally move our young people today?"
    },
    "102": {
        "startTime": 681.681,
        "endTime": 689.104,
        "transcript": "Piciryramteńek wall' umyuaqegtaarmek qaillun tamatumek nallunrirceciiqeceta?",
        "translation": "How will we let them know about our traditions or good mindsets?"
    },
    "103": {
        "startTime": 690.091,
        "endTime": 697.197,
        "transcript": "Unuakumi tupallratni arcaqerluki ayuqucirturluki assirluki.",
        "translation": "Particularly when they wake up in the morning, instruct them well."
    },
    "104": {
        "startTime": 697.206,
        "endTime": 703.584,
        "transcript": "Nuu, makut wani maa-i ak'a ellmeggnek umyuameggnek atungelriit.",
        "translation": "No, these [youth] are now starting to follow their own minds."
    },
    "105": {
        "startTime": 703.594,
        "endTime": 707.394,
        "transcript": "Qaillun-gguq tamakut kitugcugngaciqceta?",
        "translation": "How will we be able to fix them?"
    },
    "106": {
        "startTime": 707.768,
        "endTime": 714.679,
        "transcript": "Kitugcugngaaput ava-i au͡gkut ciuliamta kitugculaiciicetun.",
        "translation": "We can fix them how our ancestors back then used to fix them."
    },
    "107": {
        "startTime": 714.696,
        "endTime": 722.23,
        "transcript": "Ayuqucirtualuki, qalaruqu'urluki, eq'ukuavkenaki unganaqluki tau͡gaam.",
        "translation": "Continually instruct them, speak to them, do not be harsh with them but make them feel affectionate."
    },
    "108": {
        "startTime": 722.237,
        "endTime": 724.826,
        "transcript": "Maligcugnaqluta ellaitnun.",
        "translation": "Let them want to obey us."
    },
    "109": {
        "startTime": 724.84,
        "endTime": 737.051,
        "transcript": "Tuaten ayuqengraata, assiilngurmek-llu atungraata atullrat caknerpak ikiarassiyaagpek'naku, tau͡gaam inerqualuki kenekluki.",
        "translation": "Though they're like that, and even if they do bad things, do not despise the bad things they do too much, but admonish and love them."
    },
    "110": {
        "startTime": 737.062,
        "endTime": 744.773,
        "transcript": "Iqua-llu tamana atullra assiilucia nasvagluku, tuaten ayuqnaqniluku.",
        "translation": "And explain to him the bad consequence of what he's doing, saying that he needs to be [better] like that."
    },
    "111": {
        "startTime": 746.266,
        "endTime": 752.943,
        "transcript": "Una-gguq-am nunualuku pilria, wall'u qancurlagalluku pilria",
        "translation": "They say that one who always scolds him, or speaks harshly to him"
    },
    "112": {
        "startTime": 752.946,
        "endTime": 759.124,
        "transcript": "Wall'u waten: \"Elpenek-wa pingnaqluten qanrut'ngerpet niicugpek'nak tuaten ayuqellriaten,\"",
        "translation": "Or like this: \"Since you did it by yourself though you were told and disobedient, you are like that,\""
    },
    "113": {
        "startTime": 759.143,
        "endTime": 766.443,
        "transcript": "Imutun-gguq kaugtuutatun tuknitauq taumun tuaten qanrucunailngurmun.",
        "translation": "They said that that is as forceful as a club to that one who does not heed advice."
    },
    "114": {
        "startTime": 766.444,
        "endTime": 775.722,
        "transcript": "Tau͡gken-gguq waten pikuni: \"Cangallruyuksia elpeni? Elpetun ayuqua wii.\"",
        "translation": "However, they said that if one says this: \"How different do you think I am from you? I am like you.\""
    },
    "115": {
        "startTime": 775.999,
        "endTime": 781.766,
        "transcript": "Yuk tamarmi ataucimek umyuangqertuq, umyuallgutekluni.",
        "translation": "Every person has one mind, is of one mind."
    },
    "116": {
        "startTime": 781.767,
        "endTime": 792.623,
        "transcript": "Tau͡gaam qanruyutem-gguq ukanirpak yuk taumek aprumallrungraan, assiitellriamek-llu yuk aprumallrungraan",
        "translation": "But, they said that historically, the traditional wisdom, though a person was called that, and though a person was called bad"
    },
    "117": {
        "startTime": 792.635,
        "endTime": 799.335,
        "transcript": "Uum-gguq tau͡gaam yuum qanran kitugtetua ukanirpak umyualinqigtelluku-llu",
        "translation": "They said that a person's mouth has always fixed him, and makes him change his ways"
    },
    "118": {
        "startTime": 799.348,
        "endTime": 802.214,
        "transcript": "Mernuyagucuunaku.",
        "translation": "Without getting tired of his [bad ways]."
    },
    "119": {
        "startTime": 802.932,
        "endTime": 810.788,
        "transcript": "Tuamta-llu nerinisngialliqsuunani, \"Qaku niisngalriarurteqatarta?\" Tuaten-gguq piksaunaku.",
        "translation": "Then, do not be impatient, \"When is he going to become obedient?\" They said not to say that to him."
    },
    "120": {
        "startTime": 810.789,
        "endTime": 819.0,
        "transcript": "Qacuiqsaunaku-gguq qalaruqurallermikun kitugtarkaugaa tuaten ayuqellria.",
        "translation": "They said that one must not despair, but try to fix one who like that by speaking to him."
    },
    "121": {
        "startTime": 820.354,
        "endTime": 828.865,
        "transcript": "Ak'a tamaani qasgingqetullratni qasgini yun'erraat qalarutetullruit elitnaurluki-llu cayaraitnek.",
        "translation": "When they had community houses a long time ago, they would speak to the young men and teach them what to do in those community houses."
    },
    "122": {
        "startTime": 828.871,
        "endTime": 840.126,
        "transcript": "Tau͡gaam maa-i mat'um nalliini elitnaurvignek akmaken tekitanek elitnauristengut allakarmeng piciryaralegnek.",
        "translation": "But these days, in schools from way out there, they're getting teachers who have separate cultures."
    },
    "123": {
        "startTime": 840.859,
        "endTime": 843.937,
        "transcript": "Ukverit-llu allakaunruluteng.",
        "translation": "And their beliefs are very different."
    },
    "124": {
        "startTime": 843.954,
        "endTime": 849.81,
        "transcript": "Cali mat'um tiiviim arcaqerluni tuacetun elitnaurvigmi.",
        "translation": "And especially TV's like that in schools."
    },
    "125": {
        "startTime": 849.811,
        "endTime": 860.466,
        "transcript": "Yaa, tuaten watua mat'um nalliini ayagyuaput allat piciryarameggnek mat'um elitnaullrata",
        "translation": "Yes, through our youth learning about others' cultures these days"
    },
    "126": {
        "startTime": 860.654,
        "endTime": 871.754,
        "transcript": "Tuaten ayuqlirivkarai qanrucunairulluki, umyuarteng aturluku, nepengluteng pinginanermeggni TV-nek.",
        "translation": "It's causing them to be like that, not heeding advice, following their own mind, starting commotion as they are watching TV."
    },
    "127": {
        "startTime": 873.773,
        "endTime": 875.684,
        "transcript": "Tangvagluteng.",
        "translation": "They watch it."
    },
    "128": {
        "startTime": 875.693,
        "endTime": 881.982,
        "transcript": "Ukut-llu makut piciryarat Bible-aat waten ayuqucirturluta:",
        "translation": "And this Bible instructs us like this:"
    },
    "129": {
        "startTime": 881.989,
        "endTime": 895.355,
        "transcript": "\"Iingita aglumayaraq tau͡gaam kiingan tangvagaat, tegliurluteng, tuquciluteng, akusrarutekiluteng.\"",
        "translation": "\"Their eyes are only watching desire, stealing, killing each other, and committing adultery.\""
    },
    "130": {
        "startTime": 895.365,
        "endTime": 899.787,
        "transcript": "Iimteggun tungaunaki tamakut tangvagluki.",
        "translation": "We are looking right at those with our eyes."
    },
    "131": {
        "startTime": 899.794,
        "endTime": 908.838,
        "transcript": "Tamaa-i tamatum arcaqerluki iqlutmurutai Kass'am mat'um piciryaraan yup'ut.",
        "translation": "That Western culture is especially leading our people astray."
    },
    "132": {
        "startTime": 910.258,
        "endTime": 913.919,
        "transcript": "Tua-ll' avavet ukveqkengamteńun.",
        "translation": "Then to what we believe."
    },
    "133": {
        "startTime": 913.93,
        "endTime": 924.03,
        "transcript": "Yuk ukverpek'nani calritesciigatuq, naulluutni-llu elluarrluku ukverpek'nani kitugingaunaku.",
        "translation": "A person without faith cannot be healthy, and he will not fix his sickness well without faith."
    },
    "134": {
        "startTime": 925.661,
        "endTime": 928.45,
        "transcript": "Iluumuulriaruuq tamana.",
        "translation": "That is the truth."
    },
    "135": {
        "startTime": 928.464,
        "endTime": 935.653,
        "transcript": "Ak'a qanemcimariut tamakut tuaten ukverpek'nateng yuullermeggni.",
        "translation": "Those people who live without faith like that are already told about."
    },
    "136": {
        "startTime": 935.666,
        "endTime": 944.61,
        "transcript": "Ukut Bible-aat qanrutaitkut, \"Qanrucunailnguq-gguq ukvelriarunrituq.\" Tuaten qanertut Bible-aat.",
        "translation": "The Bible tells us, \"A person who does not heed advice does not believe.\" That's what the Bible says."
    },
    "137": {
        "startTime": 944.621,
        "endTime": 954.432,
        "transcript": "Avani-llu tua-i tuaten wangkutni Yupiani tuaten aterpagingauq ukvelriarunrilngurmek qanrucunailnguq.",
        "translation": "And back then among us Yupiat, a person who does not heed advice is called a non-believer."
    },
    "138": {
        "startTime": 954.986,
        "endTime": 961.686,
        "transcript": "Ukvertalriarunrilngurmek aterpagingauq qanrucunailnguq.",
        "translation": "One who does not heed advice is called one without faith."
    },
    "139": {
        "startTime": 962.075,
        "endTime": 967.353,
        "transcript": "Ciuliamta tuaten tua-i avaken aterpagingaluku tauna.",
        "translation": "Since a long time ago, that's what our ancestors called that person."
    },
    "140": {
        "startTime": 967.355,
        "endTime": 975.033,
        "transcript": "Tauna-llu-gguq ukvelriarunrilami qanrucunailngurmi yuucurlagtuq-gguq.",
        "translation": "And they said that since the one who does not heed advice does not believe, he is living a bad life."
    },
    "141": {
        "startTime": 975.033,
        "endTime": 979.789,
        "transcript": "Imuuyaaqeciquq-gguq piqunqeggluni pinirliuluni-llu",
        "translation": "They said that he may be agile and strong"
    },
    "142": {
        "startTime": 979.808,
        "endTime": 993.552,
        "transcript": "Tau͡gken-gguq ukut ciuliarneret, au͡gkut ciuliamta, tauna waten caciilnguq qanrucunaunani tau͡gken pilria waten qanrutkaat:",
        "translation": "However, they said that these elders, our ancestors back then, instead say this about that person who does not know what he's doing and does not heed advice:"
    },
    "143": {
        "startTime": 993.561,
        "endTime": 995.427,
        "transcript": "Au͡gtarnaqniluku.",
        "translation": "He is inhibiting."
    },
    "144": {
        "startTime": 995.437,
        "endTime": 1002.893,
        "transcript": "Imutun-gguq ayuquq, tuquniaralriit au͡gtarnarinilaraput mat'um nalliiini.",
        "translation": "They say he is like one, these days we say those on the verge of death are inhibiting."
    },
    "145": {
        "startTime": 1002.905,
        "endTime": 1011.116,
        "transcript": "Tauna-gguq qanrucunailnguq umyuani aturyukii tuaten ayuquq au͡gtarnaqluni-gguq.",
        "translation": "They said that one who does not heed advice and follows his own mind is like that, inhibiting."
    },
    "146": {
        "startTime": 1011.128,
        "endTime": 1019.805,
        "transcript": "Waten-gguq piarkauguq: caciilnginanermini-gguq alqunaq tayimqertarkauguq paallagluni waten:",
        "translation": "They said he is fated to do this: as he does not know what he's doing, he will suddenly disappear, stumbling like this:"
    },
    "147": {
        "startTime": 1019.82,
        "endTime": 1026.575,
        "transcript": "Kill'uni, wall'u tuqutauluni, wall'u ellminek akngirrluni.",
        "translation": "Sinking, or is killed, or he hurts himself."
    },
    "148": {
        "startTime": 1026.581,
        "endTime": 1028.903,
        "transcript": "Alqunaq tua-i tuquluni.",
        "translation": "He suddenly dies."
    },
    "149": {
        "startTime": 1028.918,
        "endTime": 1038.307,
        "transcript": "Waniwa-gguq paallagluni caciilnginanermini uqilalimek wall'u pinirlimek aterpagingallrung'e'rmi.",
        "translation": "They say that he \"stumbles\" while he doesn't know what hes doing, even though he was called a fast or strong person."
    },
    "150": {
        "startTime": 1038.824,
        "endTime": 1046.336,
        "transcript": "Tamana-gguq pitekluku qanrucunailnguut au͡gtarnarqellrianek aterpagtelallruit ciuliamta.",
        "translation": "They said that for that reason, our ancestors called those who do not heed advice inhibiting."
    },
    "151": {
        "startTime": 1047.018,
        "endTime": 1055.363,
        "transcript": "Yupiit wani qanruyutengqertut imucetun tua-i commandment-aaqluku, alerquutnek. Aturtait elluarrluteng piaqluteng.",
        "translation": "Yupiit have traditional wisdom that are like their commandments, instructions. Those who follow them do well."
    },
    "152": {
        "startTime": 1055.375,
        "endTime": 1062.619,
        "transcript": "Iliit una wani alerquutemta ayuquq: imkut wangkutni...",
        "translation": "One of our instructions is like this: those of us..."
    },
    "153": {
        "startTime": 1063.847,
        "endTime": 1069.624,
        "transcript": "Waten-llu cali ayuqluni tamana qalaruciyaraq ciuliamteńi:",
        "translation": "And speaking like that is like this for our ancestors:"
    },
    "154": {
        "startTime": 1070.485,
        "endTime": 1079.819,
        "transcript": "Yuk-gguq ata tang umyuaqacaulria yuum allam yuinek ayuqucirturiyuitellria yuk.",
        "translation": "They say a person who is not very mindful does not instruct others' children."
    },
    "155": {
        "startTime": 1080.057,
        "endTime": 1088.002,
        "transcript": "Ukut tau͡gaam nakmiin yun'i kiingita ayuqucirtuagaqluki elluarrluki pillerkaatnek.",
        "translation": "He only instructs his very own children on how they should do well."
    },
    "156": {
        "startTime": 1088.014,
        "endTime": 1091.303,
        "transcript": "Allam-gguq tau͡gken yua ayuqucirtuayuunaku.",
        "translation": "They said, however, that he does not instruct another's child."
    },
    "157": {
        "startTime": 1091.311,
        "endTime": 1098.978,
        "transcript": "Tamakut-gguq tuaten ayuqellriit aterpagingaut umyuaqacagnek kiimurrsulrianek-llu.",
        "translation": "They said that those who are like that are called unmindful and stingy [with knowledge]."
    },
    "158": {
        "startTime": 1099.211,
        "endTime": 1108.511,
        "transcript": "Ukut-gguq irniani tuaten elluarrluki pisqumangraitki, pisumange'rmiki",
        "translation": "They said that though they want their children to do well"
    },
    "159": {
        "startTime": 1109.078,
        "endTime": 1115.345,
        "transcript": "Uum allam yui pegingaluki ayuqucirciiganaki-llu.",
        "translation": "They disregard another's child and cannot instruct him."
    },
    "160": {
        "startTime": 1115.684,
        "endTime": 1126.173,
        "transcript": "Imna-gguq tamana tuaten umyuangqellra ukut nakmiin yui assiisqumangraateng atami",
        "translation": "They said that one with that mindset, though their father wants his own children to be good"
    },
    "161": {
        "startTime": 1126.479,
        "endTime": 1131.501,
        "transcript": "Taukut-gguq tau͡gaam irniari tuaten ayuqeciqut.",
        "translation": "They said that his chidlren instead will be [bad] like that."
    },
    "162": {
        "startTime": 1131.819,
        "endTime": 1142.519,
        "transcript": "Au͡gkut tau͡gken imkut qanruteksailkai ayuqucirtuqsailkai imna im' umyugaa taukut-gguq tau͡gaam aturciqaat.",
        "translation": "However, those children that he has not spoken to or instructed, they said that they will do what [he wants his children to] in his mind."
    },
    "163": {
        "startTime": 1142.529,
        "endTime": 1154.018,
        "transcript": "Tuamta-llu-gguq waten yuk iqlutun umyugiuskumteggu assiitesqelluku wangkutnun-gguq tau͡gaam tememteńun tuciiquq.",
        "translation": "Then, they said that if we wish bad things upon a person, it will instead come upon our body."
    },
    "164": {
        "startTime": 1154.022,
        "endTime": 1159.6,
        "transcript": "Tuaten tamaa-i pulengtaq atulaamegteggu tanglaamegteggu-llu",
        "translation": "Since they've repeatedly experienced and seen that"
    },
    "165": {
        "startTime": 1159.607,
        "endTime": 1172.596,
        "transcript": "Yuk umyualinqigtaqami ayuqucillni umyuakacaullni-llu qanrutkelallrunilliat tuaten yuk kingumini ayuqesqevkenaku.",
        "translation": "When a person changed his ways and his unmindfulness, they would talk about that so that the person in the next genertion would not be like that."
    },
    "166": {
        "startTime": 1172.605,
        "endTime": 1178.561,
        "transcript": "Umyuakacauluku yuusqevkenaku, yuuluaqallerkaa tau͡gaam apertualuku.",
        "translation": "They told him not to live unmindfully, but showed him how to live well."
    },
    "167": {
        "startTime": 1178.568,
        "endTime": 1182.735,
        "transcript": "Talluqevkenaku yuk elluarrluku pisqumaluku.",
        "translation": "Without being embarrassed, he wants a person to do well."
    },
    "168": {
        "startTime": 1182.751,
        "endTime": 1190.217,
        "transcript": "Umyualinqigtaqami-gguq yuk tuaten ayuqlirilartuq tangellni tamalkuan ayuqucirturluku.",
        "translation": "They say a person who changes his ways becomes like that, instructing on everything he's seen."
    },
    "169": {
        "startTime": 1190.223,
        "endTime": 1196.035,
        "transcript": "Tua-i-llu waten ellangellemni malrugnek arnagnek tangvallruunga.",
        "translation": "Then when I was growing up, I watched two women."
    },
    "170": {
        "startTime": 1196.048,
        "endTime": 1204.804,
        "transcript": "Akiarmi allanrungraan nutaan-llu tangenge'rmiu ayuqucirturluku elluarrluku pillerkaanek.",
        "translation": "In Akiak, though [another] was a guest and she saw him for the first time, she instructing him on how to do well."
    },
    "171": {
        "startTime": 1204.813,
        "endTime": 1208.202,
        "transcript": "Qalarruugulluku angliulluku-llu.",
        "translation": "She spoke to and enjoyed [the time] with him."
    },
    "172": {
        "startTime": 1208.216,
        "endTime": 1214.094,
        "transcript": "Aipaa-llu Kuinerrarmi cali tuaten ayuqluni nutaan.",
        "translation": "And the other was especially like that in Quinhagak."
    },
    "173": {
        "startTime": 1214.107,
        "endTime": 1224.34,
        "transcript": "Kass'aq-llu Yugtun taringyuilengraan taringetulitun pitarrluku qalarulluku, engelallagalluku, angliulluku cakneq.",
        "translation": "Even though the Caucasian didn't understand Yup'ik, she spoke to her as if he did, making her laugh, really enjoying [the time] with her."
    },
    "174": {
        "startTime": 1224.351,
        "endTime": 1229.04,
        "transcript": "Pitatekluki tuaten angliulluki.",
        "translation": "They enjoyed [their time] with them without discrimination."
    },
    "175": {
        "startTime": 1229.048,
        "endTime": 1235.314,
        "transcript": "Tua-i-llu piqerluni arnat iliita Kass'aq agayuvigmi qanertuq",
        "translation": "Then one day, one of the Caucasian women said in church"
    },
    "176": {
        "startTime": 1235.332,
        "endTime": 1247.188,
        "transcript": "Tauna-gguq elliini umyugaani nallunaitqapigmek Paradise-aamun tuqullermini ayallruuq tuaten ayuqngan.",
        "translation": "She said that it was very certin in her mind that when she died, she went to Paradise because she was like that."
    },
    "177": {
        "startTime": 1247.342,
        "endTime": 1251.82,
        "transcript": "Yuk tamalkuan qalarulluku ayuqucirturluku-llu.",
        "translation": "She spoke to and isntructed every person."
    },
    "178": {
        "startTime": 1251.823,
        "endTime": 1257.723,
        "transcript": "Tua-i-gguq tauna ellualriaruuq yuk tamalkuan pisqumakii elluarrluku.",
        "translation": "They say that one who wants every person to do well is righteous."
    },
    "179": {
        "startTime": 1257.737,
        "endTime": 1265.959,
        "transcript": "Wangkuta-gguq ikayuqengkilta akilillerkarput taumun egmianun umyuaqevkenaku.",
        "translation": "They say that we should help others without thinking of being immediately paid by that person."
    },
    "180": {
        "startTime": 1266.232,
        "endTime": 1277.587,
        "transcript": "Ayuqucirtuutnguuq tamana waten, ukuni-llu Bible-aani Peter-aam igaini naaqilartua waten:",
        "translation": "That is a traditional instruction like this, and I read this in the Bible in Peter's writings:"
    },
    "181": {
        "startTime": 1277.591,
        "endTime": 1286.747,
        "transcript": "\"Uumun ciuligteńgulriamun ukut yuut qalarutesqelluki ciuliqaggluki-llu elluarrluki pillerkaatnek.",
        "translation": "\"To one who is a leader, he should speak to and lead these people to do well."
    },
    "182": {
        "startTime": 1286.763,
        "endTime": 1294.286,
        "transcript": "\"Akingutkellerkaat-llu umyuaqevkenaki, tau͡gaam ciuliqagtellriatun elluam tungiinun.\"",
        "translation": "\"And do not think about being paid, but to lead them to righteousness.\""
    }
};